<template>
  <div class="reader">
    <div>
      <vs-row style="margin-top: 10px" justify="center" id="nav-reader">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="0" xs="1" sm="1" class="showWhenSmall">
          <div class="showWhenSmall">
            <vs-button active floating icon gradient @click="wantsPadding = !wantsPadding" v-if="readingType === '3' && wantsPadding === true">
              <i class='bx bxs-dock-bottom'></i>
            </vs-button>
            <vs-button active floating icon gradient @click="wantsPadding = !wantsPadding" v-if="readingType === '3' && wantsPadding === false">
              <i class='bx bx-dock-bottom'></i>
            </vs-button>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="3" xs="1" sm="1" class="hideWhenSmall">
          <div style="display: flex !important; float: right;">
            <vs-select placeholder="Zoom" v-model="zoomPercent" @change="changedZoom">
              <vs-option
                  v-for="zoom in possibleZoom"
                  :label="zoom.text"
                  :value="zoom.value"
                  :key="zoom.id">
                {{ zoom.text }}
              </vs-option>
            </vs-select>
          </div>
        </vs-col>
        <vs-col w="1">
          <div style="display: flex !important; float: right;" v-if="isLoading === false"> <!-- readingType === '1' -->
            <vs-button active floating icon gradient @click="activeChapterSelect = true;">
              <i class='bx bx-list-ul'></i>
            </vs-button>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="3" style="" xs="6" sm="6">
          <div>
            <div v-if="readingType === '1' && isLoading === false">
              <vs-pagination v-model="currPage" :length="jsonOnePage.length" class="showWhenSmall" style="justify-content: left !important;">
                <vs-select v-model="currPage">
                  <vs-option
                      v-for="(page, index) in jsonOnePage"
                      :label="page['#']"
                      :value="index + 1"
                      :key="index + 1">
                    {{ page['#'] }}
                  </vs-option>
                </vs-select>
              </vs-pagination>
            </div>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="3" xs="1" sm="1">
          <div style="display: flex !important;">
            <div class="hideWhenSmall">
              <vs-select placeholder="Tipo de lectura" v-model="readingType"> <!-- @change="changeReadingType" -->
                <vs-option label="Paginada" value="1">
                  Paginada (cada una)
                </vs-option>
                <!-- <vs-option label="Paginada 2" value="2">
                  Paginada
                </vs-option> -->
                <vs-option label="Cascada" value="3">
                  Cascada
                </vs-option>
              </vs-select>
            </div>
            <div class="showWhenSmall">
              <vs-button active floating icon gradient @click="readingType = '3'" v-if="readingType === '1'">
                <!-- Paginated one -->
                <i class='bx bxs-file-blank'></i>
              </vs-button>
              <vs-button active floating icon gradient @click="readingType = '1'" v-if="readingType === '3'">
                <!-- Cascade -->
                <i class='bx bxs-down-arrow-circle bx'></i>
              </vs-button>
            </div>
            <vs-button active floating icon gradient @click="wantsPadding = !wantsPadding" v-if="readingType === '3' && wantsPadding === true">
              <i class='bx bxs-dock-bottom'></i>
            </vs-button>
            <vs-button active floating icon gradient @click="wantsPadding = !wantsPadding" v-if="readingType === '3' && wantsPadding === false">
              <i class='bx bx-dock-bottom'></i>
            </vs-button>
          </div>
        </vs-col>
      </vs-row>
    </div>
    <div class="pageview" v-if="isLoading === false">
      <ul id="viewer" class="animate fit" style="overflow-y: auto;" v-if="readingType === '1'">
        <li :style="`left: 0px; top: 0px; height: ` + initialHeight + `px;`">
          <article class="page cover">
            <aside class="interactive" style="left: -3.5px; top: 0px;"></aside>
            <canvas id="canvas1" style="position: absolute; z-index: 1; top: 0px;" width="909" height="1190" class="blank" data-drawed="true"></canvas>
            <div class="html-page" :style="`width: ` + initialWidth + `px; height: ` + initialHeight + `px;`">
              <div id="p1" :style="`-webkit-transform-origin: 0 0; overflow: hidden; position: relative; background-color: white; width: ` + initialWidth + `px; height: ` +  initialHeight + `px; background-image: url('` + this.jsonOnePage[currPage - 1].u + `'); background-size: 100% 100%`"></div>
            </div>
          </article>
        </li>
      </ul>
      <ul id="viewer2" class="animate fit" style="overflow-y: auto;" v-if="readingType === '3'">
        <li :class="wantsPadding ? 'padding' : ''" :style="`left: 0px; top: 0px; height: ` + initialHeight + `px;`" v-for="page in jsonOnePage" :key="page.id" :data-page="page['#']">
          <article class="page cover">
            <aside class="interactive" style="left: -3.5px; top: 0px;"></aside>
            <canvas style="position: absolute; z-index: 1; top: 0px;" width="909" height="1190" class="blank" data-drawed="true"></canvas>
            <div :class="'html-page ' + (wantsPadding ? 'shadow' : '')" :style="`width: ` + initialWidth + `px; height: ` + initialHeight + `px;`">
              <!-- <div class="inside-page cascade-type" :style="`width: ` + initialWidth + `px; height: ` +  initialHeight + `px;` /* background-image: url('` + page.u + `')` */" :data-bg="page.u"></div> -->
              <lazy-background
                  :image-source="page.u"
                  loading-image="/img/loading.svg"
                  error-image="/img/error.png"
                  image-class="inside-page cascade-type"
                  background-size="100% 100%"
                  additional-style="width: 100%; height: 100%"
              > <!-- :image-success-callback="successCallback" :image-error-callback="errorCallback" -->
              </lazy-background>
            </div>
          </article>
        </li>
      </ul>
    </div>
    <div v-if="readingType === '1' && isLoading === false" style="margin-top: 10px; margin-bottom: 10px;">
      <!-- <vs-pagination v-model="currPage" :length="jsonOnePage.length" class="showWhenSmall">
        <vs-select v-model="currPage" @change="scrollUp">
          <vs-option
              v-for="numberPage in jsonOnePage.length"
              :label="numberPage"
              :value="numberPage"
              :key="numberPage.id">
            {{ numberPage }}
          </vs-option>
        </vs-select>s
      </vs-pagination> -->
      <vs-pagination v-model="currPage" :length="jsonOnePage.length" class="showWhenSmall">
        <vs-select v-model="currPage" @change="scrollUp">
          <vs-option
              v-for="(page, index) in jsonOnePage"
              :label="page['#']"
              :value="index + 1"
              :key="index + 1">
            {{ page['#'] }}
          </vs-option>
        </vs-select>
      </vs-pagination>
    </div>
    <vs-dialog overflow-hidden v-model="activeChapterSelect">
      <template #header>
        <h3>
          Capítulos de este libro
        </h3>
      </template>
      <div class="con-content" v-for="capitulo in chapters" :key="capitulo.id">
        <vs-button block @click="goToPage(capitulo.page); activeChapterSelect = false;">
          {{ capitulo.name }} - Página {{ capitulo.page }}
        </vs-button>
      </div>
    </vs-dialog>
    <!-- {{this.$route.params.uuid}} -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ReaderView",
  data() {
    return {
      screenProperties: {
        width: 0,
        height: 0
      },
      book: {},
      jsonMain: {},
      currPage: 1,
      readingType: '1',
      linkJson: 'https://www.anvi.club/editores/videnti/lectorem/json/?uuid=' + this.$route.params.uuid,
      jsonOnePage: [],
      jsonDoublePage: {},
      currentJSONType: null,
      chapters: [],
      zoomPercent: 1,
      pageAspectRadio: {
        width: 1016,
        height: 1330
      },
      activeChapterSelect: false,
      wantsPadding: true, // true para cuando SÍ quiera padeo
      possibleZoom: [
        { value: 1, text: "Encajar v." }, /*
        { value: 2, text: "10%" },
        { value: 3, text: "20%" },
        { value: 4, text: "30%" },
        { value: 5, text: "40%" }, */
        { value: 6, text: "+20%" },
        { value: 7, text: "+40%" },
        { value: 8, text: "+60%" },
        { value: 9, text: "+80%" },
        { value: 10, text: "+90%" },
        { value: 12, text: "+95%" },
        { value: 13, text: "Encajar h." }
      ],
      // initialHeight: ((95 / 100) * window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight).toFixed(2),
      // initialWidth: ((216 / 279) * ((95 / 100) * window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight).toFixed(2)).toFixed(2),
      initialHeight: ((95 / 100) * window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight).toFixed(2),
      initialWidth: ((216 / 279) * ((95 / 100) * window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight).toFixed(2)).toFixed(2),
      isLoading: true
    }
  },
  async mounted() {
    const loading = this.$vs.loading({
      background: '#000',
      color: '#fff',
      text: 'Cargando...'
    })
    await axios
        .get(this.linkJson)
        .then(ress => {
          if (ress.data.error) {
            const daddy = window.self;
            daddy.opener = window.self;
            daddy.close();
          } else {
            this.jsonMain = ress.data;
          }
        })
    // this.jsonDoublePage = this.jsonMain.chapters

    switch (this.jsonMain.version) {
      case "1.1":
        for (let i = 0; i < this.jsonMain.chapters.length; i++) {
          // console.log(this.jsonMain.chapters[i]);
          let jsonToPush = {name: "", page: "" };
          jsonToPush.name = this.jsonMain.chapters[i].name;
          jsonToPush.page = this.jsonMain.chapters[i].pages[0].left['#'];
          this.chapters.push(jsonToPush);
          for (let i2 = 0; i2 < this.jsonMain.chapters[i].pages.length; i2++) {
            // console.log(this.jsonMain.chapters[i].pages[i2]);
            this.jsonOnePage.push(this.jsonMain.chapters[i].pages[i2].left);
            if (this.jsonMain.chapters[i].pages[i2].right) {
              this.jsonOnePage.push(this.jsonMain.chapters[i].pages[i2].right);
            }
          }
        }
        if (this.jsonMain.options.defaultReading) {
          console.log('La paginación inicial y deseada es ' + this.jsonMain.options.defaultReading);
        }
        break;
      case "2.1":
        for (let i = 0; i < this.jsonMain.chapters.length; i++) {
          // console.log(this.jsonMain.chapters[i]);
          let jsonToPush = {name: "", page: "" };
          jsonToPush.name = this.jsonMain.chapters[i].name;
          jsonToPush.page = this.jsonMain.chapters[i].pages[0]['#'];
          this.chapters.push(jsonToPush);
          for (let i2 = 0; i2 < this.jsonMain.chapters[i].pages.length; i2++) {
            // console.log(this.jsonMain.chapters[i].pages[i2]);
            this.jsonOnePage.push(this.jsonMain.chapters[i].pages[i2]);
          }
        }

        if (this.jsonMain.options.pageAspect.width && this.jsonMain.options.pageAspect.height) {
          // console.log('La paginación inicial y deseada es ' + this.jsonMain.options.defaultReading);
          this.pageAspectRadio.width = this.jsonMain.options.pageAspect.width;
          this.pageAspectRadio.height = this.jsonMain.options.pageAspect.height;
        }
        break;

      case "3.0":
        for (let i = 0; i < this.jsonMain.chapters.length; i++) {
          let jsonToPush = { name: "", page: "", end: "" };

          jsonToPush.name = this.jsonMain.chapters[i].name;
          jsonToPush.page = this.jsonMain.chapters[i].start;
          jsonToPush.end = this.jsonMain.chapters[i].end;

          this.chapters.push(jsonToPush);
        }

        if (this.jsonMain.options.useDynamicPages === true) {
          const prefix = (this.jsonMain.dynamicPages.useBaseURL ? this.jsonMain.options.baseURL : "") + this.jsonMain.dynamicPages.prefix;
          const suffix = this.jsonMain.dynamicPages.suffix;
          let padZero = 0;
          if (this.jsonMain.dynamicPages.paddingZeros) {
            padZero = this.jsonMain.dynamicPages.qtyDigits;
          }

          for (let i = this.jsonMain.dynamicPages.start; i <= this.jsonMain.dynamicPages.end; i++) {
            // console.log("Adding page " + i);
            let jsonToPush = { "#": "", u: "" };

            jsonToPush["#"] = i;
            if (padZero !== 0) {
              jsonToPush.u = prefix + i.zeroPad(padZero) + suffix;
            } else {
              jsonToPush.u = prefix + i + suffix;
            }

            this.jsonOnePage.push(jsonToPush);
          }
        } else {
          for (let i = 0; i < this.jsonMain.pages.length; i++) {
            this.jsonOnePage.push(this.jsonMain.pages[i]);
          }
        }
        break;
    }

    if((screen.availHeight > screen.availWidth) || (window.innerHeight > window.innerWidth)){
      this.zoomPercent = 12;
    }


    /* alert('https://www.anvico.club/editores/videnti/lectorem/json/' + this.$route.params.uuid + '.json') */

    loading.close();
    this.isLoading = false;
  },
  created() {
    window.addEventListener("resize", this.changedZoom);
    this.screenProperties.width = window.innerWidth;
    this.screenProperties.height = window.innerHeight;
  },
  destroyed() {
    window.removeEventListener("resize", this.changedZoom);
  },
  methods: {
    goToPage(page) {
      if (this.readingType === '1') {
        this.currPage = this.jsonOnePage.findIndex(x => x['#'] === page) + 1
      } else if (this.readingType === '3') {
        document.querySelector(`[data-page="${page}"]`).scrollIntoView({ behavior: "smooth" });
      }
    },
    changedZoom() {
      this.screenProperties.width = window.innerWidth;
      this.screenProperties.height = window.innerHeight;

      let idZoom = this.zoomPercent;
      let newWidth; let newHeight;

      switch (parseInt(idZoom)) {
        case 13: // Full Width
          newWidth = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2);
          newHeight = ((this.pageAspectRadio.height / this.pageAspectRadio.width) * (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2)).toFixed(2);
          break;
        case 12: // 95% - Almost Full
          newWidth = ((95 / 100) * window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2);
          newHeight = ((this.pageAspectRadio.height / this.pageAspectRadio.width) * (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2)).toFixed(2);
          break;
        case 10: // 90%
          newWidth = ((85 / 100) * window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2);
          newHeight = (85 / 100) * ((this.pageAspectRadio.height / this.pageAspectRadio.width) * (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2)).toFixed(2);
          break;
        case 9: // 80%
          newWidth = ((75 / 100) * window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2);
          newHeight = (75 / 100) * ((this.pageAspectRadio.height / this.pageAspectRadio.width) * (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2)).toFixed(2);
          break;
        case 8:
          newWidth = ((65 / 100) * window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2);
          newHeight = (65 / 100) * ((this.pageAspectRadio.height / this.pageAspectRadio.width) * (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2)).toFixed(2);
          break;
        case 7:
          newWidth = ((55 / 100) * window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2);
          newHeight = (55 / 100) * ((this.pageAspectRadio.height / this.pageAspectRadio.width) * (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2)).toFixed(2);
          break;
        case 6:
          newWidth = ((45 / 100) * window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2);
          newHeight = (45 / 100) * ((this.pageAspectRadio.height / this.pageAspectRadio.width) * (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth).toFixed(2)).toFixed(2);
          break;
        default:
        case 1: // Full Height
          newWidth = ((this.pageAspectRadio.width / this.pageAspectRadio.height) * ((95 / 100) * window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight).toFixed(2)).toFixed(2);
          newHeight = ((95 / 100) * window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight).toFixed(2);
          break;
      }

      this.initialHeight = newHeight;
      this.initialWidth = newWidth;

      // FALLBACK
      if((screen.availHeight > screen.availWidth) || (window.innerHeight > window.innerWidth)){
        this.zoomPercent = 12;
      }
    },
    scrollUp() {
      // console.log('called scrollup');
      // window.scrollTo(0, 0);
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  },
  metaInfo() {
    return {
      title: 'Lector',
      // titleTemplate: '%s - Buscar en Videnti',
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf8' },
        { name: 'robots', content: 'noindex' }
      ]
    }
  }
}
</script>

<!-- Local style -->
<style scoped lang="scss">
@import "~@elbuenanvita/vuesax/src/styles/mixins";

@include media-breakpoint-down("sm") {
  #nav-reader {
    position: fixed;
    z-index: 100;
  }

  #viewer, #viewer2 {
    padding-top: 3rem;
  }
}
</style>

<style scoped>
.pageview {
  margin-top: 1%;
}

#viewer {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  white-space: nowrap;
}

ul, ol {
  list-style: none;
  padding: 0;
  margin: 0;
}

#viewer > li {
  position: relative;
  width: auto;
  /* width: 100%; */
  height: 100%;
  padding: 5px;
  /* display: inline-block; */
  display: list-item;
  text-align: center;
  -webkit-transform: translate3d(0,0,0);
  -webkit-backface-visibility: hidden;
  /* transform-origin: 0 0; */
  /* -webkit-overflow-scrolling: touch; */
  /* -webkit-transform-origin: 0 0; */
}

#viewer.single .page, #viewer .page.cover {
  width: 100%;
  text-align: center !important;
}

#viewer .page {
  position: relative;
  width: 50%;
  height: 100%;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
}

/* #viewer .page:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -.25em;
} */

#viewer .page img, #viewer .page canvas {
  background-size: contain;
}

#viewer .page img, #viewer .page > canvas {
  width: 90%;
  height: 90%;
  display: inline-block;
  vertical-align: middle;
}

#viewer .page .html-page {
  display: inline-block;
  vertical-align: middle;
  box-shadow: 0 0 3px 0 #444444;
  background: #FFFFFF no-repeat center;
}

#viewer2.single .page, #viewer2 .page.cover {
  width: 100%;
  text-align: center !important;
}

#viewer2 .page img, #viewer2 .page > canvas {
  width: 90%;
  height: 90%;
  display: inline-block;
  vertical-align: middle;
}

#viewer2 .page {
  position: relative;
  width: 50%;
  height: 100%;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
}

#viewer2 > li {
  position: relative;
  width: auto;
  /* width: 100%; */
  height: 100%;
  /* padding: 5px; */
  padding-left: 5px;
  padding-right: 5px;
  /* display: inline-block; */
  display: list-item;
  text-align: center;
  -webkit-transform: translate3d(0,0,0);
  -webkit-backface-visibility: hidden;
  /* transform-origin: 0 0; */
  /* -webkit-overflow-scrolling: touch; */
  /* -webkit-transform-origin: 0 0; */
}

#viewer2 {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  white-space: nowrap;
}

#viewer2 .page .html-page {
  display: inline-block;
  vertical-align: middle;
  /* box-shadow: 0 0 3px 0 #444444; */
  background: #FFFFFF no-repeat center;
}

#viewer2 .page .shadow {
  box-shadow: 0 0 3px 0 #444444;
}

#viewer2 > li.padding {
  padding: 5px;
}

/* @media (orientation: portrait) {
  .vs-select-content {
    max-width: 50px;
  }
} */

#nav-reader {
  /* position: fixed;
  z-index: 999; */
}

.inside-page.cascade-type {
  -webkit-transform-origin: 0 0;
  overflow: hidden;
  position: relative;
  background-color: white;
  background-size: 100% 100%;
}
</style>
